<div class="fab-items fixed right" style="display:none">

    <div class="fab-singleItem">
        <!-- 'mat-button','mat-raised-button', 'mat-flat-button','mat-stroked-button','mat-icon-button','mat-fab','mat-mini-fab' -->
        <button mat-fab color="primary">
            <mat-icon class="fab-icon">account_circle</mat-icon>
        </button>
        <span class="fab-title">مهمان</span>

    </div>

</div>


<div class="fab-items fixed left" style="display:none">

    <div class="fab-singleItem">
        <!-- 'mat-button','mat-raised-button', 'mat-flat-button','mat-stroked-button','mat-icon-button','mat-fab','mat-mini-fab' -->
        <button mat-raised-button color="primary">هوش کامپیوتری</button>
    </div>

</div>

<!-- <router-outlet></router-outlet> -->

<payeha [respectfulName]="respectfulName"></payeha>